import React from 'react';
import '../Styles/FadingLine.css'; // Create this CSS file

function FadingLine() {
  return (
    <div className="fading-line" >
    </div>
  );
}

export default FadingLine;